/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** Big number integer */
  BigInt: { input: any; output: any };
  /** A date-time string in simplified extended ISO 8601 format (YYYY-MM-DDTHH:mm:ss.sssZ) */
  DateTime: { input: any; output: any };
};

export type ExtrinsicFailed = {
  __typename?: 'ExtrinsicFailed';
  blockHash: Scalars['String']['output'];
  blockNumber: Scalars['Int']['output'];
  docs: Array<Scalars['String']['output']>;
  errorName: Scalars['String']['output'];
  extrinsicHash: Scalars['String']['output'];
  /** ${BlockNumber}-${EventId} */
  id: Scalars['String']['output'];
  pallet: Scalars['String']['output'];
  rewardPeriod: RewardPeriod;
};

export type ExtrinsicFailedEdge = {
  __typename?: 'ExtrinsicFailedEdge';
  cursor: Scalars['String']['output'];
  node: ExtrinsicFailed;
};

export enum ExtrinsicFailedOrderByInput {
  BlockHashAsc = 'blockHash_ASC',
  BlockHashAscNullsFirst = 'blockHash_ASC_NULLS_FIRST',
  BlockHashAscNullsLast = 'blockHash_ASC_NULLS_LAST',
  BlockHashDesc = 'blockHash_DESC',
  BlockHashDescNullsFirst = 'blockHash_DESC_NULLS_FIRST',
  BlockHashDescNullsLast = 'blockHash_DESC_NULLS_LAST',
  BlockNumberAsc = 'blockNumber_ASC',
  BlockNumberAscNullsFirst = 'blockNumber_ASC_NULLS_FIRST',
  BlockNumberAscNullsLast = 'blockNumber_ASC_NULLS_LAST',
  BlockNumberDesc = 'blockNumber_DESC',
  BlockNumberDescNullsFirst = 'blockNumber_DESC_NULLS_FIRST',
  BlockNumberDescNullsLast = 'blockNumber_DESC_NULLS_LAST',
  ErrorNameAsc = 'errorName_ASC',
  ErrorNameAscNullsFirst = 'errorName_ASC_NULLS_FIRST',
  ErrorNameAscNullsLast = 'errorName_ASC_NULLS_LAST',
  ErrorNameDesc = 'errorName_DESC',
  ErrorNameDescNullsFirst = 'errorName_DESC_NULLS_FIRST',
  ErrorNameDescNullsLast = 'errorName_DESC_NULLS_LAST',
  ExtrinsicHashAsc = 'extrinsicHash_ASC',
  ExtrinsicHashAscNullsFirst = 'extrinsicHash_ASC_NULLS_FIRST',
  ExtrinsicHashAscNullsLast = 'extrinsicHash_ASC_NULLS_LAST',
  ExtrinsicHashDesc = 'extrinsicHash_DESC',
  ExtrinsicHashDescNullsFirst = 'extrinsicHash_DESC_NULLS_FIRST',
  ExtrinsicHashDescNullsLast = 'extrinsicHash_DESC_NULLS_LAST',
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST',
  PalletAsc = 'pallet_ASC',
  PalletAscNullsFirst = 'pallet_ASC_NULLS_FIRST',
  PalletAscNullsLast = 'pallet_ASC_NULLS_LAST',
  PalletDesc = 'pallet_DESC',
  PalletDescNullsFirst = 'pallet_DESC_NULLS_FIRST',
  PalletDescNullsLast = 'pallet_DESC_NULLS_LAST',
  RewardPeriodIdAsc = 'rewardPeriod_id_ASC',
  RewardPeriodIdAscNullsFirst = 'rewardPeriod_id_ASC_NULLS_FIRST',
  RewardPeriodIdAscNullsLast = 'rewardPeriod_id_ASC_NULLS_LAST',
  RewardPeriodIdDesc = 'rewardPeriod_id_DESC',
  RewardPeriodIdDescNullsFirst = 'rewardPeriod_id_DESC_NULLS_FIRST',
  RewardPeriodIdDescNullsLast = 'rewardPeriod_id_DESC_NULLS_LAST',
  RewardPeriodIndexAsc = 'rewardPeriod_index_ASC',
  RewardPeriodIndexAscNullsFirst = 'rewardPeriod_index_ASC_NULLS_FIRST',
  RewardPeriodIndexAscNullsLast = 'rewardPeriod_index_ASC_NULLS_LAST',
  RewardPeriodIndexDesc = 'rewardPeriod_index_DESC',
  RewardPeriodIndexDescNullsFirst = 'rewardPeriod_index_DESC_NULLS_FIRST',
  RewardPeriodIndexDescNullsLast = 'rewardPeriod_index_DESC_NULLS_LAST',
}

export type ExtrinsicFailedWhereInput = {
  AND?: InputMaybe<Array<ExtrinsicFailedWhereInput>>;
  OR?: InputMaybe<Array<ExtrinsicFailedWhereInput>>;
  blockHash_contains?: InputMaybe<Scalars['String']['input']>;
  blockHash_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  blockHash_endsWith?: InputMaybe<Scalars['String']['input']>;
  blockHash_eq?: InputMaybe<Scalars['String']['input']>;
  blockHash_gt?: InputMaybe<Scalars['String']['input']>;
  blockHash_gte?: InputMaybe<Scalars['String']['input']>;
  blockHash_in?: InputMaybe<Array<Scalars['String']['input']>>;
  blockHash_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  blockHash_lt?: InputMaybe<Scalars['String']['input']>;
  blockHash_lte?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_contains?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_eq?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  blockHash_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  blockHash_startsWith?: InputMaybe<Scalars['String']['input']>;
  blockNumber_eq?: InputMaybe<Scalars['Int']['input']>;
  blockNumber_gt?: InputMaybe<Scalars['Int']['input']>;
  blockNumber_gte?: InputMaybe<Scalars['Int']['input']>;
  blockNumber_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  blockNumber_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  blockNumber_lt?: InputMaybe<Scalars['Int']['input']>;
  blockNumber_lte?: InputMaybe<Scalars['Int']['input']>;
  blockNumber_not_eq?: InputMaybe<Scalars['Int']['input']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  docs_containsAll?: InputMaybe<Array<Scalars['String']['input']>>;
  docs_containsAny?: InputMaybe<Array<Scalars['String']['input']>>;
  docs_containsNone?: InputMaybe<Array<Scalars['String']['input']>>;
  docs_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  errorName_contains?: InputMaybe<Scalars['String']['input']>;
  errorName_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  errorName_endsWith?: InputMaybe<Scalars['String']['input']>;
  errorName_eq?: InputMaybe<Scalars['String']['input']>;
  errorName_gt?: InputMaybe<Scalars['String']['input']>;
  errorName_gte?: InputMaybe<Scalars['String']['input']>;
  errorName_in?: InputMaybe<Array<Scalars['String']['input']>>;
  errorName_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  errorName_lt?: InputMaybe<Scalars['String']['input']>;
  errorName_lte?: InputMaybe<Scalars['String']['input']>;
  errorName_not_contains?: InputMaybe<Scalars['String']['input']>;
  errorName_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  errorName_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  errorName_not_eq?: InputMaybe<Scalars['String']['input']>;
  errorName_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  errorName_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  errorName_startsWith?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_contains?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_endsWith?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_eq?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_gt?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_gte?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_in?: InputMaybe<Array<Scalars['String']['input']>>;
  extrinsicHash_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  extrinsicHash_lt?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_lte?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_not_contains?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_not_eq?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  extrinsicHash_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
  pallet_contains?: InputMaybe<Scalars['String']['input']>;
  pallet_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  pallet_endsWith?: InputMaybe<Scalars['String']['input']>;
  pallet_eq?: InputMaybe<Scalars['String']['input']>;
  pallet_gt?: InputMaybe<Scalars['String']['input']>;
  pallet_gte?: InputMaybe<Scalars['String']['input']>;
  pallet_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pallet_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  pallet_lt?: InputMaybe<Scalars['String']['input']>;
  pallet_lte?: InputMaybe<Scalars['String']['input']>;
  pallet_not_contains?: InputMaybe<Scalars['String']['input']>;
  pallet_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  pallet_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  pallet_not_eq?: InputMaybe<Scalars['String']['input']>;
  pallet_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  pallet_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  pallet_startsWith?: InputMaybe<Scalars['String']['input']>;
  rewardPeriod?: InputMaybe<RewardPeriodWhereInput>;
  rewardPeriod_isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExtrinsicFailedsConnection = {
  __typename?: 'ExtrinsicFailedsConnection';
  edges: Array<ExtrinsicFailedEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FailedLower = {
  __typename?: 'FailedLower';
  amount: Scalars['String']['output'];
  blockHash: Scalars['String']['output'];
  blockNumber: Scalars['BigInt']['output'];
  blockTimestamp: Scalars['DateTime']['output'];
  error: Scalars['String']['output'];
  extrinsic?: Maybe<ExtrinsicFailed>;
  extrinsicHash: Scalars['String']['output'];
  from: Scalars['String']['output'];
  id: Scalars['String']['output'];
  rewardPeriodIndex?: Maybe<Scalars['Int']['output']>;
  t1Recipient: Scalars['String']['output'];
  tokenId: Scalars['String']['output'];
};

export type FailedLowerEdge = {
  __typename?: 'FailedLowerEdge';
  cursor: Scalars['String']['output'];
  node: FailedLower;
};

export enum FailedLowerOrderByInput {
  AmountAsc = 'amount_ASC',
  AmountAscNullsFirst = 'amount_ASC_NULLS_FIRST',
  AmountAscNullsLast = 'amount_ASC_NULLS_LAST',
  AmountDesc = 'amount_DESC',
  AmountDescNullsFirst = 'amount_DESC_NULLS_FIRST',
  AmountDescNullsLast = 'amount_DESC_NULLS_LAST',
  BlockHashAsc = 'blockHash_ASC',
  BlockHashAscNullsFirst = 'blockHash_ASC_NULLS_FIRST',
  BlockHashAscNullsLast = 'blockHash_ASC_NULLS_LAST',
  BlockHashDesc = 'blockHash_DESC',
  BlockHashDescNullsFirst = 'blockHash_DESC_NULLS_FIRST',
  BlockHashDescNullsLast = 'blockHash_DESC_NULLS_LAST',
  BlockNumberAsc = 'blockNumber_ASC',
  BlockNumberAscNullsFirst = 'blockNumber_ASC_NULLS_FIRST',
  BlockNumberAscNullsLast = 'blockNumber_ASC_NULLS_LAST',
  BlockNumberDesc = 'blockNumber_DESC',
  BlockNumberDescNullsFirst = 'blockNumber_DESC_NULLS_FIRST',
  BlockNumberDescNullsLast = 'blockNumber_DESC_NULLS_LAST',
  BlockTimestampAsc = 'blockTimestamp_ASC',
  BlockTimestampAscNullsFirst = 'blockTimestamp_ASC_NULLS_FIRST',
  BlockTimestampAscNullsLast = 'blockTimestamp_ASC_NULLS_LAST',
  BlockTimestampDesc = 'blockTimestamp_DESC',
  BlockTimestampDescNullsFirst = 'blockTimestamp_DESC_NULLS_FIRST',
  BlockTimestampDescNullsLast = 'blockTimestamp_DESC_NULLS_LAST',
  ErrorAsc = 'error_ASC',
  ErrorAscNullsFirst = 'error_ASC_NULLS_FIRST',
  ErrorAscNullsLast = 'error_ASC_NULLS_LAST',
  ErrorDesc = 'error_DESC',
  ErrorDescNullsFirst = 'error_DESC_NULLS_FIRST',
  ErrorDescNullsLast = 'error_DESC_NULLS_LAST',
  ExtrinsicHashAsc = 'extrinsicHash_ASC',
  ExtrinsicHashAscNullsFirst = 'extrinsicHash_ASC_NULLS_FIRST',
  ExtrinsicHashAscNullsLast = 'extrinsicHash_ASC_NULLS_LAST',
  ExtrinsicHashDesc = 'extrinsicHash_DESC',
  ExtrinsicHashDescNullsFirst = 'extrinsicHash_DESC_NULLS_FIRST',
  ExtrinsicHashDescNullsLast = 'extrinsicHash_DESC_NULLS_LAST',
  ExtrinsicBlockHashAsc = 'extrinsic_blockHash_ASC',
  ExtrinsicBlockHashAscNullsFirst = 'extrinsic_blockHash_ASC_NULLS_FIRST',
  ExtrinsicBlockHashAscNullsLast = 'extrinsic_blockHash_ASC_NULLS_LAST',
  ExtrinsicBlockHashDesc = 'extrinsic_blockHash_DESC',
  ExtrinsicBlockHashDescNullsFirst = 'extrinsic_blockHash_DESC_NULLS_FIRST',
  ExtrinsicBlockHashDescNullsLast = 'extrinsic_blockHash_DESC_NULLS_LAST',
  ExtrinsicBlockNumberAsc = 'extrinsic_blockNumber_ASC',
  ExtrinsicBlockNumberAscNullsFirst = 'extrinsic_blockNumber_ASC_NULLS_FIRST',
  ExtrinsicBlockNumberAscNullsLast = 'extrinsic_blockNumber_ASC_NULLS_LAST',
  ExtrinsicBlockNumberDesc = 'extrinsic_blockNumber_DESC',
  ExtrinsicBlockNumberDescNullsFirst = 'extrinsic_blockNumber_DESC_NULLS_FIRST',
  ExtrinsicBlockNumberDescNullsLast = 'extrinsic_blockNumber_DESC_NULLS_LAST',
  ExtrinsicErrorNameAsc = 'extrinsic_errorName_ASC',
  ExtrinsicErrorNameAscNullsFirst = 'extrinsic_errorName_ASC_NULLS_FIRST',
  ExtrinsicErrorNameAscNullsLast = 'extrinsic_errorName_ASC_NULLS_LAST',
  ExtrinsicErrorNameDesc = 'extrinsic_errorName_DESC',
  ExtrinsicErrorNameDescNullsFirst = 'extrinsic_errorName_DESC_NULLS_FIRST',
  ExtrinsicErrorNameDescNullsLast = 'extrinsic_errorName_DESC_NULLS_LAST',
  ExtrinsicExtrinsicHashAsc = 'extrinsic_extrinsicHash_ASC',
  ExtrinsicExtrinsicHashAscNullsFirst = 'extrinsic_extrinsicHash_ASC_NULLS_FIRST',
  ExtrinsicExtrinsicHashAscNullsLast = 'extrinsic_extrinsicHash_ASC_NULLS_LAST',
  ExtrinsicExtrinsicHashDesc = 'extrinsic_extrinsicHash_DESC',
  ExtrinsicExtrinsicHashDescNullsFirst = 'extrinsic_extrinsicHash_DESC_NULLS_FIRST',
  ExtrinsicExtrinsicHashDescNullsLast = 'extrinsic_extrinsicHash_DESC_NULLS_LAST',
  ExtrinsicIdAsc = 'extrinsic_id_ASC',
  ExtrinsicIdAscNullsFirst = 'extrinsic_id_ASC_NULLS_FIRST',
  ExtrinsicIdAscNullsLast = 'extrinsic_id_ASC_NULLS_LAST',
  ExtrinsicIdDesc = 'extrinsic_id_DESC',
  ExtrinsicIdDescNullsFirst = 'extrinsic_id_DESC_NULLS_FIRST',
  ExtrinsicIdDescNullsLast = 'extrinsic_id_DESC_NULLS_LAST',
  ExtrinsicPalletAsc = 'extrinsic_pallet_ASC',
  ExtrinsicPalletAscNullsFirst = 'extrinsic_pallet_ASC_NULLS_FIRST',
  ExtrinsicPalletAscNullsLast = 'extrinsic_pallet_ASC_NULLS_LAST',
  ExtrinsicPalletDesc = 'extrinsic_pallet_DESC',
  ExtrinsicPalletDescNullsFirst = 'extrinsic_pallet_DESC_NULLS_FIRST',
  ExtrinsicPalletDescNullsLast = 'extrinsic_pallet_DESC_NULLS_LAST',
  FromAsc = 'from_ASC',
  FromAscNullsFirst = 'from_ASC_NULLS_FIRST',
  FromAscNullsLast = 'from_ASC_NULLS_LAST',
  FromDesc = 'from_DESC',
  FromDescNullsFirst = 'from_DESC_NULLS_FIRST',
  FromDescNullsLast = 'from_DESC_NULLS_LAST',
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST',
  RewardPeriodIndexAsc = 'rewardPeriodIndex_ASC',
  RewardPeriodIndexAscNullsFirst = 'rewardPeriodIndex_ASC_NULLS_FIRST',
  RewardPeriodIndexAscNullsLast = 'rewardPeriodIndex_ASC_NULLS_LAST',
  RewardPeriodIndexDesc = 'rewardPeriodIndex_DESC',
  RewardPeriodIndexDescNullsFirst = 'rewardPeriodIndex_DESC_NULLS_FIRST',
  RewardPeriodIndexDescNullsLast = 'rewardPeriodIndex_DESC_NULLS_LAST',
  T1RecipientAsc = 't1Recipient_ASC',
  T1RecipientAscNullsFirst = 't1Recipient_ASC_NULLS_FIRST',
  T1RecipientAscNullsLast = 't1Recipient_ASC_NULLS_LAST',
  T1RecipientDesc = 't1Recipient_DESC',
  T1RecipientDescNullsFirst = 't1Recipient_DESC_NULLS_FIRST',
  T1RecipientDescNullsLast = 't1Recipient_DESC_NULLS_LAST',
  TokenIdAsc = 'tokenId_ASC',
  TokenIdAscNullsFirst = 'tokenId_ASC_NULLS_FIRST',
  TokenIdAscNullsLast = 'tokenId_ASC_NULLS_LAST',
  TokenIdDesc = 'tokenId_DESC',
  TokenIdDescNullsFirst = 'tokenId_DESC_NULLS_FIRST',
  TokenIdDescNullsLast = 'tokenId_DESC_NULLS_LAST',
}

export type FailedLowerWhereInput = {
  AND?: InputMaybe<Array<FailedLowerWhereInput>>;
  OR?: InputMaybe<Array<FailedLowerWhereInput>>;
  amount_contains?: InputMaybe<Scalars['String']['input']>;
  amount_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  amount_endsWith?: InputMaybe<Scalars['String']['input']>;
  amount_eq?: InputMaybe<Scalars['String']['input']>;
  amount_gt?: InputMaybe<Scalars['String']['input']>;
  amount_gte?: InputMaybe<Scalars['String']['input']>;
  amount_in?: InputMaybe<Array<Scalars['String']['input']>>;
  amount_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  amount_lt?: InputMaybe<Scalars['String']['input']>;
  amount_lte?: InputMaybe<Scalars['String']['input']>;
  amount_not_contains?: InputMaybe<Scalars['String']['input']>;
  amount_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  amount_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  amount_not_eq?: InputMaybe<Scalars['String']['input']>;
  amount_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  amount_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  amount_startsWith?: InputMaybe<Scalars['String']['input']>;
  blockHash_contains?: InputMaybe<Scalars['String']['input']>;
  blockHash_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  blockHash_endsWith?: InputMaybe<Scalars['String']['input']>;
  blockHash_eq?: InputMaybe<Scalars['String']['input']>;
  blockHash_gt?: InputMaybe<Scalars['String']['input']>;
  blockHash_gte?: InputMaybe<Scalars['String']['input']>;
  blockHash_in?: InputMaybe<Array<Scalars['String']['input']>>;
  blockHash_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  blockHash_lt?: InputMaybe<Scalars['String']['input']>;
  blockHash_lte?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_contains?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_eq?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  blockHash_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  blockHash_startsWith?: InputMaybe<Scalars['String']['input']>;
  blockNumber_eq?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockNumber_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  blockNumber_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not_eq?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockTimestamp_eq?: InputMaybe<Scalars['DateTime']['input']>;
  blockTimestamp_gt?: InputMaybe<Scalars['DateTime']['input']>;
  blockTimestamp_gte?: InputMaybe<Scalars['DateTime']['input']>;
  blockTimestamp_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  blockTimestamp_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  blockTimestamp_lt?: InputMaybe<Scalars['DateTime']['input']>;
  blockTimestamp_lte?: InputMaybe<Scalars['DateTime']['input']>;
  blockTimestamp_not_eq?: InputMaybe<Scalars['DateTime']['input']>;
  blockTimestamp_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  error_contains?: InputMaybe<Scalars['String']['input']>;
  error_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  error_endsWith?: InputMaybe<Scalars['String']['input']>;
  error_eq?: InputMaybe<Scalars['String']['input']>;
  error_gt?: InputMaybe<Scalars['String']['input']>;
  error_gte?: InputMaybe<Scalars['String']['input']>;
  error_in?: InputMaybe<Array<Scalars['String']['input']>>;
  error_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  error_lt?: InputMaybe<Scalars['String']['input']>;
  error_lte?: InputMaybe<Scalars['String']['input']>;
  error_not_contains?: InputMaybe<Scalars['String']['input']>;
  error_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  error_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  error_not_eq?: InputMaybe<Scalars['String']['input']>;
  error_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  error_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  error_startsWith?: InputMaybe<Scalars['String']['input']>;
  extrinsic?: InputMaybe<ExtrinsicFailedWhereInput>;
  extrinsicHash_contains?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_endsWith?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_eq?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_gt?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_gte?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_in?: InputMaybe<Array<Scalars['String']['input']>>;
  extrinsicHash_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  extrinsicHash_lt?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_lte?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_not_contains?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_not_eq?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  extrinsicHash_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_startsWith?: InputMaybe<Scalars['String']['input']>;
  extrinsic_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  from_contains?: InputMaybe<Scalars['String']['input']>;
  from_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  from_endsWith?: InputMaybe<Scalars['String']['input']>;
  from_eq?: InputMaybe<Scalars['String']['input']>;
  from_gt?: InputMaybe<Scalars['String']['input']>;
  from_gte?: InputMaybe<Scalars['String']['input']>;
  from_in?: InputMaybe<Array<Scalars['String']['input']>>;
  from_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  from_lt?: InputMaybe<Scalars['String']['input']>;
  from_lte?: InputMaybe<Scalars['String']['input']>;
  from_not_contains?: InputMaybe<Scalars['String']['input']>;
  from_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  from_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  from_not_eq?: InputMaybe<Scalars['String']['input']>;
  from_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  from_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  from_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
  rewardPeriodIndex_eq?: InputMaybe<Scalars['Int']['input']>;
  rewardPeriodIndex_gt?: InputMaybe<Scalars['Int']['input']>;
  rewardPeriodIndex_gte?: InputMaybe<Scalars['Int']['input']>;
  rewardPeriodIndex_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  rewardPeriodIndex_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  rewardPeriodIndex_lt?: InputMaybe<Scalars['Int']['input']>;
  rewardPeriodIndex_lte?: InputMaybe<Scalars['Int']['input']>;
  rewardPeriodIndex_not_eq?: InputMaybe<Scalars['Int']['input']>;
  rewardPeriodIndex_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  t1Recipient_contains?: InputMaybe<Scalars['String']['input']>;
  t1Recipient_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  t1Recipient_endsWith?: InputMaybe<Scalars['String']['input']>;
  t1Recipient_eq?: InputMaybe<Scalars['String']['input']>;
  t1Recipient_gt?: InputMaybe<Scalars['String']['input']>;
  t1Recipient_gte?: InputMaybe<Scalars['String']['input']>;
  t1Recipient_in?: InputMaybe<Array<Scalars['String']['input']>>;
  t1Recipient_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  t1Recipient_lt?: InputMaybe<Scalars['String']['input']>;
  t1Recipient_lte?: InputMaybe<Scalars['String']['input']>;
  t1Recipient_not_contains?: InputMaybe<Scalars['String']['input']>;
  t1Recipient_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  t1Recipient_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  t1Recipient_not_eq?: InputMaybe<Scalars['String']['input']>;
  t1Recipient_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  t1Recipient_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  t1Recipient_startsWith?: InputMaybe<Scalars['String']['input']>;
  tokenId_contains?: InputMaybe<Scalars['String']['input']>;
  tokenId_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  tokenId_endsWith?: InputMaybe<Scalars['String']['input']>;
  tokenId_eq?: InputMaybe<Scalars['String']['input']>;
  tokenId_gt?: InputMaybe<Scalars['String']['input']>;
  tokenId_gte?: InputMaybe<Scalars['String']['input']>;
  tokenId_in?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenId_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  tokenId_lt?: InputMaybe<Scalars['String']['input']>;
  tokenId_lte?: InputMaybe<Scalars['String']['input']>;
  tokenId_not_contains?: InputMaybe<Scalars['String']['input']>;
  tokenId_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  tokenId_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  tokenId_not_eq?: InputMaybe<Scalars['String']['input']>;
  tokenId_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenId_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  tokenId_startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type FailedLowersConnection = {
  __typename?: 'FailedLowersConnection';
  edges: Array<FailedLowerEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FailedVote = {
  __typename?: 'FailedVote';
  blockHash: Scalars['String']['output'];
  blockNumber: Scalars['BigInt']['output'];
  extrinsic?: Maybe<ExtrinsicFailed>;
  extrinsicHash?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  result: Scalars['String']['output'];
  rewardPeriodIndex: Scalars['Int']['output'];
  solutionNamespace: Scalars['String']['output'];
  votingRoundId: Scalars['String']['output'];
  workerAddress: Scalars['String']['output'];
};

export type FailedVoteEdge = {
  __typename?: 'FailedVoteEdge';
  cursor: Scalars['String']['output'];
  node: FailedVote;
};

export enum FailedVoteOrderByInput {
  BlockHashAsc = 'blockHash_ASC',
  BlockHashAscNullsFirst = 'blockHash_ASC_NULLS_FIRST',
  BlockHashAscNullsLast = 'blockHash_ASC_NULLS_LAST',
  BlockHashDesc = 'blockHash_DESC',
  BlockHashDescNullsFirst = 'blockHash_DESC_NULLS_FIRST',
  BlockHashDescNullsLast = 'blockHash_DESC_NULLS_LAST',
  BlockNumberAsc = 'blockNumber_ASC',
  BlockNumberAscNullsFirst = 'blockNumber_ASC_NULLS_FIRST',
  BlockNumberAscNullsLast = 'blockNumber_ASC_NULLS_LAST',
  BlockNumberDesc = 'blockNumber_DESC',
  BlockNumberDescNullsFirst = 'blockNumber_DESC_NULLS_FIRST',
  BlockNumberDescNullsLast = 'blockNumber_DESC_NULLS_LAST',
  ExtrinsicHashAsc = 'extrinsicHash_ASC',
  ExtrinsicHashAscNullsFirst = 'extrinsicHash_ASC_NULLS_FIRST',
  ExtrinsicHashAscNullsLast = 'extrinsicHash_ASC_NULLS_LAST',
  ExtrinsicHashDesc = 'extrinsicHash_DESC',
  ExtrinsicHashDescNullsFirst = 'extrinsicHash_DESC_NULLS_FIRST',
  ExtrinsicHashDescNullsLast = 'extrinsicHash_DESC_NULLS_LAST',
  ExtrinsicBlockHashAsc = 'extrinsic_blockHash_ASC',
  ExtrinsicBlockHashAscNullsFirst = 'extrinsic_blockHash_ASC_NULLS_FIRST',
  ExtrinsicBlockHashAscNullsLast = 'extrinsic_blockHash_ASC_NULLS_LAST',
  ExtrinsicBlockHashDesc = 'extrinsic_blockHash_DESC',
  ExtrinsicBlockHashDescNullsFirst = 'extrinsic_blockHash_DESC_NULLS_FIRST',
  ExtrinsicBlockHashDescNullsLast = 'extrinsic_blockHash_DESC_NULLS_LAST',
  ExtrinsicBlockNumberAsc = 'extrinsic_blockNumber_ASC',
  ExtrinsicBlockNumberAscNullsFirst = 'extrinsic_blockNumber_ASC_NULLS_FIRST',
  ExtrinsicBlockNumberAscNullsLast = 'extrinsic_blockNumber_ASC_NULLS_LAST',
  ExtrinsicBlockNumberDesc = 'extrinsic_blockNumber_DESC',
  ExtrinsicBlockNumberDescNullsFirst = 'extrinsic_blockNumber_DESC_NULLS_FIRST',
  ExtrinsicBlockNumberDescNullsLast = 'extrinsic_blockNumber_DESC_NULLS_LAST',
  ExtrinsicErrorNameAsc = 'extrinsic_errorName_ASC',
  ExtrinsicErrorNameAscNullsFirst = 'extrinsic_errorName_ASC_NULLS_FIRST',
  ExtrinsicErrorNameAscNullsLast = 'extrinsic_errorName_ASC_NULLS_LAST',
  ExtrinsicErrorNameDesc = 'extrinsic_errorName_DESC',
  ExtrinsicErrorNameDescNullsFirst = 'extrinsic_errorName_DESC_NULLS_FIRST',
  ExtrinsicErrorNameDescNullsLast = 'extrinsic_errorName_DESC_NULLS_LAST',
  ExtrinsicExtrinsicHashAsc = 'extrinsic_extrinsicHash_ASC',
  ExtrinsicExtrinsicHashAscNullsFirst = 'extrinsic_extrinsicHash_ASC_NULLS_FIRST',
  ExtrinsicExtrinsicHashAscNullsLast = 'extrinsic_extrinsicHash_ASC_NULLS_LAST',
  ExtrinsicExtrinsicHashDesc = 'extrinsic_extrinsicHash_DESC',
  ExtrinsicExtrinsicHashDescNullsFirst = 'extrinsic_extrinsicHash_DESC_NULLS_FIRST',
  ExtrinsicExtrinsicHashDescNullsLast = 'extrinsic_extrinsicHash_DESC_NULLS_LAST',
  ExtrinsicIdAsc = 'extrinsic_id_ASC',
  ExtrinsicIdAscNullsFirst = 'extrinsic_id_ASC_NULLS_FIRST',
  ExtrinsicIdAscNullsLast = 'extrinsic_id_ASC_NULLS_LAST',
  ExtrinsicIdDesc = 'extrinsic_id_DESC',
  ExtrinsicIdDescNullsFirst = 'extrinsic_id_DESC_NULLS_FIRST',
  ExtrinsicIdDescNullsLast = 'extrinsic_id_DESC_NULLS_LAST',
  ExtrinsicPalletAsc = 'extrinsic_pallet_ASC',
  ExtrinsicPalletAscNullsFirst = 'extrinsic_pallet_ASC_NULLS_FIRST',
  ExtrinsicPalletAscNullsLast = 'extrinsic_pallet_ASC_NULLS_LAST',
  ExtrinsicPalletDesc = 'extrinsic_pallet_DESC',
  ExtrinsicPalletDescNullsFirst = 'extrinsic_pallet_DESC_NULLS_FIRST',
  ExtrinsicPalletDescNullsLast = 'extrinsic_pallet_DESC_NULLS_LAST',
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST',
  ResultAsc = 'result_ASC',
  ResultAscNullsFirst = 'result_ASC_NULLS_FIRST',
  ResultAscNullsLast = 'result_ASC_NULLS_LAST',
  ResultDesc = 'result_DESC',
  ResultDescNullsFirst = 'result_DESC_NULLS_FIRST',
  ResultDescNullsLast = 'result_DESC_NULLS_LAST',
  RewardPeriodIndexAsc = 'rewardPeriodIndex_ASC',
  RewardPeriodIndexAscNullsFirst = 'rewardPeriodIndex_ASC_NULLS_FIRST',
  RewardPeriodIndexAscNullsLast = 'rewardPeriodIndex_ASC_NULLS_LAST',
  RewardPeriodIndexDesc = 'rewardPeriodIndex_DESC',
  RewardPeriodIndexDescNullsFirst = 'rewardPeriodIndex_DESC_NULLS_FIRST',
  RewardPeriodIndexDescNullsLast = 'rewardPeriodIndex_DESC_NULLS_LAST',
  SolutionNamespaceAsc = 'solutionNamespace_ASC',
  SolutionNamespaceAscNullsFirst = 'solutionNamespace_ASC_NULLS_FIRST',
  SolutionNamespaceAscNullsLast = 'solutionNamespace_ASC_NULLS_LAST',
  SolutionNamespaceDesc = 'solutionNamespace_DESC',
  SolutionNamespaceDescNullsFirst = 'solutionNamespace_DESC_NULLS_FIRST',
  SolutionNamespaceDescNullsLast = 'solutionNamespace_DESC_NULLS_LAST',
  VotingRoundIdAsc = 'votingRoundId_ASC',
  VotingRoundIdAscNullsFirst = 'votingRoundId_ASC_NULLS_FIRST',
  VotingRoundIdAscNullsLast = 'votingRoundId_ASC_NULLS_LAST',
  VotingRoundIdDesc = 'votingRoundId_DESC',
  VotingRoundIdDescNullsFirst = 'votingRoundId_DESC_NULLS_FIRST',
  VotingRoundIdDescNullsLast = 'votingRoundId_DESC_NULLS_LAST',
  WorkerAddressAsc = 'workerAddress_ASC',
  WorkerAddressAscNullsFirst = 'workerAddress_ASC_NULLS_FIRST',
  WorkerAddressAscNullsLast = 'workerAddress_ASC_NULLS_LAST',
  WorkerAddressDesc = 'workerAddress_DESC',
  WorkerAddressDescNullsFirst = 'workerAddress_DESC_NULLS_FIRST',
  WorkerAddressDescNullsLast = 'workerAddress_DESC_NULLS_LAST',
}

export type FailedVoteWhereInput = {
  AND?: InputMaybe<Array<FailedVoteWhereInput>>;
  OR?: InputMaybe<Array<FailedVoteWhereInput>>;
  blockHash_contains?: InputMaybe<Scalars['String']['input']>;
  blockHash_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  blockHash_endsWith?: InputMaybe<Scalars['String']['input']>;
  blockHash_eq?: InputMaybe<Scalars['String']['input']>;
  blockHash_gt?: InputMaybe<Scalars['String']['input']>;
  blockHash_gte?: InputMaybe<Scalars['String']['input']>;
  blockHash_in?: InputMaybe<Array<Scalars['String']['input']>>;
  blockHash_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  blockHash_lt?: InputMaybe<Scalars['String']['input']>;
  blockHash_lte?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_contains?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_eq?: InputMaybe<Scalars['String']['input']>;
  blockHash_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  blockHash_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  blockHash_startsWith?: InputMaybe<Scalars['String']['input']>;
  blockNumber_eq?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_gte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  blockNumber_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  blockNumber_lt?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_lte?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not_eq?: InputMaybe<Scalars['BigInt']['input']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  extrinsic?: InputMaybe<ExtrinsicFailedWhereInput>;
  extrinsicHash_contains?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_endsWith?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_eq?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_gt?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_gte?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_in?: InputMaybe<Array<Scalars['String']['input']>>;
  extrinsicHash_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  extrinsicHash_lt?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_lte?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_not_contains?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_not_eq?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  extrinsicHash_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  extrinsicHash_startsWith?: InputMaybe<Scalars['String']['input']>;
  extrinsic_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
  result_contains?: InputMaybe<Scalars['String']['input']>;
  result_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  result_endsWith?: InputMaybe<Scalars['String']['input']>;
  result_eq?: InputMaybe<Scalars['String']['input']>;
  result_gt?: InputMaybe<Scalars['String']['input']>;
  result_gte?: InputMaybe<Scalars['String']['input']>;
  result_in?: InputMaybe<Array<Scalars['String']['input']>>;
  result_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  result_lt?: InputMaybe<Scalars['String']['input']>;
  result_lte?: InputMaybe<Scalars['String']['input']>;
  result_not_contains?: InputMaybe<Scalars['String']['input']>;
  result_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  result_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  result_not_eq?: InputMaybe<Scalars['String']['input']>;
  result_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  result_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  result_startsWith?: InputMaybe<Scalars['String']['input']>;
  rewardPeriodIndex_eq?: InputMaybe<Scalars['Int']['input']>;
  rewardPeriodIndex_gt?: InputMaybe<Scalars['Int']['input']>;
  rewardPeriodIndex_gte?: InputMaybe<Scalars['Int']['input']>;
  rewardPeriodIndex_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  rewardPeriodIndex_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  rewardPeriodIndex_lt?: InputMaybe<Scalars['Int']['input']>;
  rewardPeriodIndex_lte?: InputMaybe<Scalars['Int']['input']>;
  rewardPeriodIndex_not_eq?: InputMaybe<Scalars['Int']['input']>;
  rewardPeriodIndex_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  solutionNamespace_contains?: InputMaybe<Scalars['String']['input']>;
  solutionNamespace_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  solutionNamespace_endsWith?: InputMaybe<Scalars['String']['input']>;
  solutionNamespace_eq?: InputMaybe<Scalars['String']['input']>;
  solutionNamespace_gt?: InputMaybe<Scalars['String']['input']>;
  solutionNamespace_gte?: InputMaybe<Scalars['String']['input']>;
  solutionNamespace_in?: InputMaybe<Array<Scalars['String']['input']>>;
  solutionNamespace_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  solutionNamespace_lt?: InputMaybe<Scalars['String']['input']>;
  solutionNamespace_lte?: InputMaybe<Scalars['String']['input']>;
  solutionNamespace_not_contains?: InputMaybe<Scalars['String']['input']>;
  solutionNamespace_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  solutionNamespace_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  solutionNamespace_not_eq?: InputMaybe<Scalars['String']['input']>;
  solutionNamespace_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  solutionNamespace_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  solutionNamespace_startsWith?: InputMaybe<Scalars['String']['input']>;
  votingRoundId_contains?: InputMaybe<Scalars['String']['input']>;
  votingRoundId_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  votingRoundId_endsWith?: InputMaybe<Scalars['String']['input']>;
  votingRoundId_eq?: InputMaybe<Scalars['String']['input']>;
  votingRoundId_gt?: InputMaybe<Scalars['String']['input']>;
  votingRoundId_gte?: InputMaybe<Scalars['String']['input']>;
  votingRoundId_in?: InputMaybe<Array<Scalars['String']['input']>>;
  votingRoundId_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  votingRoundId_lt?: InputMaybe<Scalars['String']['input']>;
  votingRoundId_lte?: InputMaybe<Scalars['String']['input']>;
  votingRoundId_not_contains?: InputMaybe<Scalars['String']['input']>;
  votingRoundId_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  votingRoundId_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  votingRoundId_not_eq?: InputMaybe<Scalars['String']['input']>;
  votingRoundId_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  votingRoundId_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  votingRoundId_startsWith?: InputMaybe<Scalars['String']['input']>;
  workerAddress_contains?: InputMaybe<Scalars['String']['input']>;
  workerAddress_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  workerAddress_endsWith?: InputMaybe<Scalars['String']['input']>;
  workerAddress_eq?: InputMaybe<Scalars['String']['input']>;
  workerAddress_gt?: InputMaybe<Scalars['String']['input']>;
  workerAddress_gte?: InputMaybe<Scalars['String']['input']>;
  workerAddress_in?: InputMaybe<Array<Scalars['String']['input']>>;
  workerAddress_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  workerAddress_lt?: InputMaybe<Scalars['String']['input']>;
  workerAddress_lte?: InputMaybe<Scalars['String']['input']>;
  workerAddress_not_contains?: InputMaybe<Scalars['String']['input']>;
  workerAddress_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  workerAddress_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  workerAddress_not_eq?: InputMaybe<Scalars['String']['input']>;
  workerAddress_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  workerAddress_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  workerAddress_startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type FailedVotesConnection = {
  __typename?: 'FailedVotesConnection';
  edges: Array<FailedVoteEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor: Scalars['String']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  extrinsicFailedById?: Maybe<ExtrinsicFailed>;
  extrinsicFaileds: Array<ExtrinsicFailed>;
  extrinsicFailedsConnection: ExtrinsicFailedsConnection;
  failedLowerById?: Maybe<FailedLower>;
  failedLowers: Array<FailedLower>;
  failedLowersConnection: FailedLowersConnection;
  failedVoteById?: Maybe<FailedVote>;
  failedVotes: Array<FailedVote>;
  failedVotesConnection: FailedVotesConnection;
  rewardPeriodById?: Maybe<RewardPeriod>;
  rewardPeriods: Array<RewardPeriod>;
  rewardPeriodsConnection: RewardPeriodsConnection;
  squidStatus?: Maybe<SquidStatus>;
};

export type QueryExtrinsicFailedByIdArgs = {
  id: Scalars['String']['input'];
};

export type QueryExtrinsicFailedsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ExtrinsicFailedOrderByInput>>;
  where?: InputMaybe<ExtrinsicFailedWhereInput>;
};

export type QueryExtrinsicFailedsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<ExtrinsicFailedOrderByInput>;
  where?: InputMaybe<ExtrinsicFailedWhereInput>;
};

export type QueryFailedLowerByIdArgs = {
  id: Scalars['String']['input'];
};

export type QueryFailedLowersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FailedLowerOrderByInput>>;
  where?: InputMaybe<FailedLowerWhereInput>;
};

export type QueryFailedLowersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<FailedLowerOrderByInput>;
  where?: InputMaybe<FailedLowerWhereInput>;
};

export type QueryFailedVoteByIdArgs = {
  id: Scalars['String']['input'];
};

export type QueryFailedVotesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FailedVoteOrderByInput>>;
  where?: InputMaybe<FailedVoteWhereInput>;
};

export type QueryFailedVotesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<FailedVoteOrderByInput>;
  where?: InputMaybe<FailedVoteWhereInput>;
};

export type QueryRewardPeriodByIdArgs = {
  id: Scalars['String']['input'];
};

export type QueryRewardPeriodsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RewardPeriodOrderByInput>>;
  where?: InputMaybe<RewardPeriodWhereInput>;
};

export type QueryRewardPeriodsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy: Array<RewardPeriodOrderByInput>;
  where?: InputMaybe<RewardPeriodWhereInput>;
};

export type RewardPeriod = {
  __typename?: 'RewardPeriod';
  failedExtrinsics: Array<ExtrinsicFailed>;
  /** Reward Period Index (stringified) */
  id: Scalars['String']['output'];
  index: Scalars['Int']['output'];
};

export type RewardPeriodFailedExtrinsicsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ExtrinsicFailedOrderByInput>>;
  where?: InputMaybe<ExtrinsicFailedWhereInput>;
};

export type RewardPeriodEdge = {
  __typename?: 'RewardPeriodEdge';
  cursor: Scalars['String']['output'];
  node: RewardPeriod;
};

export enum RewardPeriodOrderByInput {
  IdAsc = 'id_ASC',
  IdAscNullsFirst = 'id_ASC_NULLS_FIRST',
  IdAscNullsLast = 'id_ASC_NULLS_LAST',
  IdDesc = 'id_DESC',
  IdDescNullsFirst = 'id_DESC_NULLS_FIRST',
  IdDescNullsLast = 'id_DESC_NULLS_LAST',
  IndexAsc = 'index_ASC',
  IndexAscNullsFirst = 'index_ASC_NULLS_FIRST',
  IndexAscNullsLast = 'index_ASC_NULLS_LAST',
  IndexDesc = 'index_DESC',
  IndexDescNullsFirst = 'index_DESC_NULLS_FIRST',
  IndexDescNullsLast = 'index_DESC_NULLS_LAST',
}

export type RewardPeriodWhereInput = {
  AND?: InputMaybe<Array<RewardPeriodWhereInput>>;
  OR?: InputMaybe<Array<RewardPeriodWhereInput>>;
  failedExtrinsics_every?: InputMaybe<ExtrinsicFailedWhereInput>;
  failedExtrinsics_none?: InputMaybe<ExtrinsicFailedWhereInput>;
  failedExtrinsics_some?: InputMaybe<ExtrinsicFailedWhereInput>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_eq?: InputMaybe<Scalars['String']['input']>;
  id_gt?: InputMaybe<Scalars['String']['input']>;
  id_gte?: InputMaybe<Scalars['String']['input']>;
  id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  id_lt?: InputMaybe<Scalars['String']['input']>;
  id_lte?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_containsInsensitive?: InputMaybe<Scalars['String']['input']>;
  id_not_endsWith?: InputMaybe<Scalars['String']['input']>;
  id_not_eq?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  id_not_startsWith?: InputMaybe<Scalars['String']['input']>;
  id_startsWith?: InputMaybe<Scalars['String']['input']>;
  index_eq?: InputMaybe<Scalars['Int']['input']>;
  index_gt?: InputMaybe<Scalars['Int']['input']>;
  index_gte?: InputMaybe<Scalars['Int']['input']>;
  index_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  index_isNull?: InputMaybe<Scalars['Boolean']['input']>;
  index_lt?: InputMaybe<Scalars['Int']['input']>;
  index_lte?: InputMaybe<Scalars['Int']['input']>;
  index_not_eq?: InputMaybe<Scalars['Int']['input']>;
  index_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type RewardPeriodsConnection = {
  __typename?: 'RewardPeriodsConnection';
  edges: Array<RewardPeriodEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SquidStatus = {
  __typename?: 'SquidStatus';
  /** The hash of the last processed finalized block */
  finalizedHash?: Maybe<Scalars['String']['output']>;
  /** The height of the last processed finalized block */
  finalizedHeight?: Maybe<Scalars['Int']['output']>;
  /** The hash of the last processed block */
  hash?: Maybe<Scalars['String']['output']>;
  /** The height of the last processed block */
  height?: Maybe<Scalars['Int']['output']>;
};

export type GetTransactionsByPeriodQueryVariables = Exact<{
  workerAddress: Scalars['String']['input'];
  rewardPeriod: Scalars['Int']['input'];
  solutionNamespace: Scalars['String']['input'];
}>;

export type GetTransactionsByPeriodQuery = {
  __typename?: 'Query';
  failedVotes: Array<{
    __typename?: 'FailedVote';
    solutionNamespace: string;
    rewardPeriodIndex: number;
    blockNumber: any;
    blockHash: string;
    result: string;
    votingRoundId: string;
    extrinsic?: { __typename?: 'ExtrinsicFailed'; errorName: string; extrinsicHash: string } | null;
  }>;
};

export type GetVotingGraphDataQueryVariables = Exact<{
  workerAddress: Scalars['String']['input'];
  solutionNamespace: Scalars['String']['input'];
}>;

export type GetVotingGraphDataQuery = {
  __typename?: 'Query';
  failedVotes: Array<{ __typename?: 'FailedVote'; result: string; rewardPeriodIndex: number }>;
};

export const GetTransactionsByPeriodDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTransactionsByPeriod' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'workerAddress' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'rewardPeriod' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'solutionNamespace' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'failedVotes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'workerAddress_eq' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'workerAddress' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'rewardPeriodIndex_eq' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'rewardPeriod' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'solutionNamespace_eq' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'solutionNamespace' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'solutionNamespace' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rewardPeriodIndex' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'extrinsic' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'errorName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'extrinsicHash' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'blockNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'blockHash' } },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } },
                { kind: 'Field', name: { kind: 'Name', value: 'votingRoundId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTransactionsByPeriodQuery, GetTransactionsByPeriodQueryVariables>;
export const GetVotingGraphDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetVotingGraphData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'workerAddress' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'solutionNamespace' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'failedVotes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'workerAddress_eq' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'workerAddress' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'solutionNamespace_eq' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'solutionNamespace' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'result' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rewardPeriodIndex' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetVotingGraphDataQuery, GetVotingGraphDataQueryVariables>;
